export interface UserCredit {
  credit: number
}
export interface AvailableOfferResponse {
    offerId: string;
    couponCode: string;
    summary: string;
    description: string;
    percentage: number;
    verticalLabel: string;
    startDate: number;
    endDate: number;
    isNextBooking: boolean;
    offerStatus: string;
    couponImageURL: string | null;
    couponBgImageURL: string | null;
    quantity: number;
    redeemStatus: number;
}

export enum driverTransactionStatus {
  All = 0,
  Completed = 2,
  Credited = 1
}

export enum CancelBookingType {
  FullCancelBooking = 2
}

export interface CancelBookingRequest {
  bookingId: number;
  type?: number;
  cancelBookingType?: number,
  slotCount?: number
}

export interface ModalData {
  id?: number;
  total: number;
  usedCredit: number;
  role?: string;
  spotCount?: number;
  showStatus?: string;
  bookingPaymentMode?: number;
  cancelType?: string;
  cancelByAdmin?: boolean;
}
export interface ParkingLot {
  id: string;
  parkingLotId: string;
  parkingLotName: string;
  rating: number;
  createdOn: number;
  companyLogo: string;
  location: Location;
  truckType: string[];
}

export interface Location {
  id: string;
  parkingLotId: string;
  country: string;
  state: string;
  latitude: number;
  longitude: number;
  address: string;
  streetView: string;
}
